module.exports = __webpack_public_path__ + "7194e2401226188f053b48d5d41ba00d.svg";